<template>
    <section
        ref="section26"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="9"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="relative flex w-full max-w-3xl flex-col gap-11">
                <v-error-display :validation-errors="validationErrors"></v-error-display>
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-2">
                    <div><v-icon icon="history-edu" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="text-heading-3-desktop">Opisi oglasa</div>
                    </div>
                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Naslov oglasa
                            </p>
                            <p class="mb-4 text-body-regular">
                                Z naslovom oglasa podate iskalcem pravi namig,
                                kaj ponujate.
                            </p>
                            <p class="mb-[10px] text-icon-text-medium">
                                Splošni opis
                            </p>
                            <p class="mb-4 text-body-regular">
                                Tukaj vnesite za bralca privlačni opis nepremičnine na način, da si želel prebrati tudi preostale informacije ponudbe.
                            </p>
                            <p class="mb-[10px] text-icon-text-medium">
                                Opis lokacije
                            </p>
                            <p class="mb-4 text-body-regular">
                                Opišite lokacijo na kateri se nepremičnina ali
                                parcela nahaja, okrožje in sosesko. Tako si
                                lahko iskalci bolje predstavljajo bivanjske
                                razmere.
                            </p>
                            <p class="mb-[10px] text-icon-text-medium">
                                Opis opreme
                            </p>
                            <p class="mb-4 text-body-regular">
                                V opisu opreme pojasnite stanje pohištva v
                                nepremičnini in stanje opremljenosti. Tako si
                                lahko potencialne stranke lažje prestavljajo
                                stanje nepremičnine in možne izdatke za
                                pohištvo.
                            </p>
                            <p class="mb-[10px] text-icon-text-medium">
                                Druge informacije
                            </p>
                            <p class="text-body-regular">
                                Opišite ostale dodatne informacije o
                                nepremičnini, če jih še niste opisali v
                                predhodnih oknih.
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <form method="POST" :action="routes.submitForm" id="add-info">
                    <v-csrf-token></v-csrf-token>
                    <figure
                        class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8"
                    >
                        <ul class="flex flex-col gap-8">
                            <li class="w-full">
                                <div
                                    :class="[
                                        'input group relative flex flex-col gap-[10px]',
                                        validationErrors.objekttitel
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="propertyTitle"
                                        class="w-full text-body-medium-button"
                                    >
                                        <div
                                            class="label flex flex-col gap-[10px]"
                                        >
                                            <div
                                                class="flex items-center gap-2"
                                            >
                                                <v-icon
                                                    icon="title"
                                                    size="4"
                                                ></v-icon>
                                                <span>
                                                    Naslov oglasa
                                                    <sup>*</sup></span
                                                >
                                            </div>
                                        </div>
                                    </label>
                                    <input
                                        id="propertyTitle"
                                        type="text"
                                        name="objekttitel"
                                        placeholder="Naslov oglasa"
                                        v-model="propertyTitle"
                                    />
                                    <small class="flex w-full justify-end text-small-text-regular text-black-40">
                                        {{ propertyTitle.length }}/100 znakov
                                    </small>
                                </div>
                            </li>

                            <li class="w-full">
                                <div
                                    :class="[
                                        'textarea group flex items-center',
                                        validationErrors.objektbeschreibung
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="propertyDescription"
                                        class="flex w-full flex-col gap-[10px] text-body-medium-button"
                                    >
                                        <div class="label flex flex-col gap-10">
                                            <div
                                                class="flex items-center justify-start gap-2"
                                            >
                                                <v-icon icon="article"></v-icon>
                                                <div
                                                    class="flex flex-col gap-[10px]"
                                                >
                                                    <div>
                                                        Splošni opis
                                                        <sup>*</sup>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <textarea
                                            id="propertyDescription"
                                            name="objektbeschreibung"
                                            placeholder="Splošni opis"
                                            rows="10"
                                            class="pl-7"
                                            v-model="propertyDescription"
                                        ></textarea>
                                        <small class="flex w-full justify-end text-small-text-regular text-black-40">
                                            {{ propertyDescription.length }}/2000 znakov
                                        </small>
                                    </label>
                                </div>
                            </li>

                            <li class="w-full">
                                <div
                                    :class="[
                                        'textarea group flex items-center',
                                        validationErrors.lage
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="locationDescription"
                                        class="flex w-full flex-col gap-[10px] text-body-medium-button"
                                    >
                                        <div class="label flex flex-col gap-10">
                                            <div
                                                class="flex items-center justify-start gap-2"
                                            >
                                                <v-icon
                                                    icon="pin-house-location"
                                                ></v-icon>
                                                <div
                                                    class="flex flex-col gap-[10px]"
                                                >
                                                    <div>
                                                        Opis lokacije
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <textarea
                                            id="locationDescription"
                                            name="lage"
                                            placeholder="Opis lokacije"
                                            rows="10"
                                            class="pl-7"
                                            v-model="locationDescription"
                                        ></textarea>
                                        <small class="flex w-full justify-end text-small-text-regular text-black-40">
                                            {{ locationDescription.length }}/2000 znakov
                                        </small>
                                    </label>
                                </div>
                            </li>

                            <li
                                class="w-full"
                                v-if="stepData.objektart != 'grundstueck'"
                            >
                                <div
                                    :class="[
                                        'textarea group flex items-center',
                                        validationErrors.ausstatt_beschr
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="equipmentDescription"
                                        class="flex w-full flex-col gap-[10px] text-body-medium-button"
                                    >
                                        <div class="label flex flex-col gap-10">
                                            <div
                                                class="flex items-center justify-start gap-2"
                                            >
                                                <v-icon icon="chair"></v-icon>
                                                <div
                                                    class="flex flex-col gap-[10px]"
                                                >
                                                    <div>
                                                        Opis opreme
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <textarea
                                            id="equipmentDescription"
                                            name="ausstatt_beschr"
                                            placeholder="Opis opreme"
                                            rows="10"
                                            class="pl-7"
                                            v-model="equipmentDescription"
                                        ></textarea>
                                        <small class="flex w-full justify-end text-small-text-regular text-black-40">
                                            {{ equipmentDescription.length }}/2000 znakov
                                        </small>
                                    </label>
                                </div>
                            </li>

                            <li class="w-full">
                                <div
                                    :class="[
                                        'textarea group flex items-center',
                                        validationErrors.sonstige_angaben
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="otherDetails"
                                        class="flex w-full flex-col gap-[10px] text-body-medium-button"
                                    >
                                        <div class="label flex flex-col gap-10">
                                            <div
                                                class="flex items-center justify-start gap-2"
                                            >
                                                <v-icon icon="notes"></v-icon>
                                                <div
                                                    class="flex flex-col gap-[10px]"
                                                >
                                                    <div>
                                                        Druge informacije
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <textarea
                                            id="otherDetails"
                                            name="sonstige_angaben"
                                            placeholder="Druge informacije"
                                            rows="10"
                                            class="pl-7"
                                            v-model="otherDetails"
                                        ></textarea>
                                        <small class="flex w-full justify-end text-small-text-regular text-black-40">
                                            {{ otherDetails.length }}/2000 znakov
                                        </small>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </figure>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                :href="routes.previousStep ? routes.previousStep : '/'"
                class="button button--white button--md h-[48px] w-[240px] px-6 mr-4"
            >
                <v-icon icon="arrow-right" class="rotate-180" size="4"></v-icon>
                <label class="text-small-text-medium">Nazaj</label>
            </a>
            <a
                @click="submitForm('add-info')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
        "v-error-display": ErrorDisplay
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            propertyTitle: '',
            propertyDescription: '',
            locationDescription: '',
            equipmentDescription: '',
            otherDetails: '',
        };
    },
    mounted() {
        this.propertyTitle = this.old.objekttitel
            ? this.old.objekttitel
            : this.stepData.objekttitel ?? '';
        this.propertyDescription = this.old.objektbeschreibung
            ? this.old.objektbeschreibung
            : this.stepData.objektbeschreibung ?? '';
        this.locationDescription = this.old.lage
            ? this.old.lage
            : this.stepData.lage ?? '';
        this.equipmentDescription = this.old.ausstatt_beschr
            ? this.old.ausstatt_beschr
            : this.stepData.ausstatt_beschr ?? '';
        this.otherDetails = this.old.sonstige_angaben
            ? this.old.sonstige_angaben
            : this.stepData.sonstige_angaben ?? '';
    },
    methods: {
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
    },
    computed: {
        validated() {
            if (
                !this.propertyTitle ||
                !this.propertyDescription
            )
                return false;

            return true;
        },
    },
};
</script>
